import {
  createSlice,
  PayloadAction,
  SliceCaseReducers,
} from "@reduxjs/toolkit";
import { RootState } from "../store";


const initialState = {
  loggedIn: false,
  userProps: {
    account_type: "",
    business_branch: "",
    business_id: "",
    email: "",
    emailVerified: false,
    name: "",
    permissions: "",
    uid: "",
    created_at: "",
  },
};

type UserPropsPayload = typeof initialState.userProps;

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logIn: (state: typeof initialState) => {
      state.loggedIn = true;
    },
    logOut: (state: typeof initialState) => {
      state.loggedIn = false;
    },
    setUserProps: (
      state: typeof initialState,
      action: PayloadAction<UserPropsPayload>
    ) => {
      state.userProps = action.payload;
    },
    resetUserProps: (state: typeof initialState) => {
      state.userProps = initialState.userProps;
    },
  },
});

export const userSliceActions = userSlice.actions;
export const selectUserLoginState = (state: RootState) => state.user.loggedIn;
export const selectUserPropsState = (state: RootState) => state.user.userProps;
export default userSlice.reducer;
